module.exports = __webpack_public_path__ + "media/07-amph-dopamine.8b899712.mp4";